import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'pennlibs-colors',
  styleUrl: 'pennlibs-colors.css',
  shadow: true
})
export class Footer {
  /**
   * The navigation sections.
   */
  @Prop() navigation: Array<{
    heading: string;
    links: Array<{
      label: string;
      href: string;
    }>;
  }>;

  render() {
    
    return (
      <div class="viewport-margins">
        <div class="colors-container">
          <section>
            <h2>Penn Brand</h2>
            <code style={{ background: "var(--color-penn-red)" }}>
              <span>var(--color-penn-red)</span>
              <span>#990000</span>
            </code>
            <code style={{ background: "var(--color-penn-blue)"}}>
              <span>var(--color-penn-blue)</span>
              <span>#011F5B</span>
            </code>
          </section>

          <section>
            <h2>Grays</h2>
            <code style={{ background: "var(--color-gray-dark)" }}>
              <span>var(--color-gray-dark)</span>
              <span>#2D3545</span>
            </code>
            <code style={{ background: "var(--color-gray)" }}>
              <span>var(--color-gray)</span>
              <span>#595F6A</span>
            </code>
            <code style={{ background: "var(--color-gray-light)" }}>
              <span>var(--color-gray-light)</span>
              <span>#F5F5F6</span>
            </code>
          </section>

          <section>
            <h2>Blue</h2>
            <code style={{ background: "var(--color-blue)" }}>
              <span>var(--color-blue)</span>
              <span>#0E5696</span>
            </code>
            <code style={{ background: "var(--color-blue-light)" }}>
              <span>var(--color-blue-light)</span>
              <span>#D4E4F2</span>
            </code>
          </section>

          <section>
            <h2>Green</h2>
            <code style={{ background: "var(--color-green)" }}>
              <span>var(--color-green)</span>
              <span>#267434</span>
            </code>
            <code style={{ background: "var(--color-green-light)" }}>
              <span>var(--color-green-light)</span>
              <span>#F1F7E1</span>
            </code>
          </section>

          <section>
            <h2>Orange</h2>
            <code style={{ background: "var(--color-orange)" }}>
              <span>var(--color-orange)</span>
              <span>#BD4718</span>
            </code>
            <code style={{ background: "var(--color-orange-light)" }}>
              <span>var(--color-orange-light)</span>
              <span>#FEEDDD</span>
            </code>
          </section>

          <section>
            <h2>Purple</h2>
            <code style={{ background: "var(--color-purple)" }}>
              <span>var(--color-purple)</span>
              <span>#80317F</span>
            </code>
            <code style={{ background: "var(--color-purple-light)" }}>
              <span>var(--color-purple-light)</span>
              <span>#F2DFED</span>
            </code>
          </section>
        </div>
      </div>
    );
  }
}
